// src/types/page/propertyColor.ts
export type PropertyColorKey =
  | "gray" | "red" | "orange" | "yellow" | "green" | "blue" | "purple";

export interface ChipColor { bg: string; fg: string }

// Muted, Notion-ish swatches. fg chosen for contrast on bg.
export const PROPERTY_COLORS: Record<PropertyColorKey, ChipColor> = {
  gray:   { bg: "#e3e2e0", fg: "#37352f" },
  red:    { bg: "#ffe2dd", fg: "#5d1715" },
  orange: { bg: "#fadec9", fg: "#5c3b23" },
  yellow: { bg: "#fdecc8", fg: "#594a1f" },
  green:  { bg: "#dbeddb", fg: "#1c3829" },
  blue:   { bg: "#d3e5ef", fg: "#183347" },
  purple: { bg: "#e8deee", fg: "#412454" },
};

export const PROPERTY_COLOR_KEYS = Object.keys(PROPERTY_COLORS) as PropertyColorKey[];

// Absent/undefined/unknown => gray.
export const resolveChipColor = (color?: string): ChipColor =>
  PROPERTY_COLORS[(color as PropertyColorKey)] ?? PROPERTY_COLORS.gray;
